import { Select } from "antd";
import React,{ useEffect, useRef, useState } from "react";
import { FullTextTag } from "../../page/VideoManagement/FullTextTag";
// import { FullTextTag } from "../../page/VideoManagement/FullTextTag";

export const TagVideoSelect = ({ tags = [], setTags = () => {}, listAll = [],className ,isAddNew}) => {
    const [inputValue, setInputValue] = useState("");
    const [options, setOptions] = useState([]);
    const [selectKey, setSelectKey] = useState(true);
    const selectRef = useRef();
  
    useEffect(() => {
      setOptions(listAll);
    }, [listAll]);
  
    const handleChange = (values) => {
      setInputValue("");
      setSelectKey(!selectKey);
      const unique = Array.from(new Set(values));
      setTags(unique);
    };
  
    const handleInputKeyDown = (e) => {
      if (e.key === "Enter" || e.key === " " || e.key === ",") {
        const trimmed = inputValue.trim();
        if (!trimmed) {
          e.preventDefault();
          return;
        }
  
        const isAlreadySelected = tags.includes(trimmed);
        const isInOptions = options.includes(trimmed);
  
        if (!isAlreadySelected) {
          const newTags = [...tags, trimmed];
          setTags(newTags);
        }
        if (!isInOptions) {
          setOptions((prev) => [...prev, trimmed]);
        }
  
        setInputValue("");
        setSelectKey(!selectKey);
        e.preventDefault();
        setTimeout(() => {
          selectRef.current.focus();
        }, 0);
      }
    };
    useEffect(() => {
      setInputValue(""); 
    }, [tags]);
    return (
      <Select
       tagRender={(props) => <FullTextTag {...props} />}
       dropdownClassName="custom-select-hover"
        showArrow
        showSearch
        ref={selectRef}
        mode="multiple"
        value={tags}
        onChange={handleChange}
        onSearch={(val) => setInputValue(val.slice(0, 255))}
        // onInputKeyDown={isAddNew ? handleInputKeyDown : () => {}}
        tokenSeparators={[]} 
        options={options.map((tag) => ({ value: tag, label: tag }))}
        className={className}
        searchValue={inputValue}
      />
    );
  };